import { generatePath } from 'react-router';
import { NavigateFunction, RouteObject } from 'react-router-dom';
import type { Location, Params } from 'react-router-dom';
import { BASE_AUTH_TOKEN } from '../constants';

export const url = (url: string, params?: any) => {
  return generatePath(url, params);
};

export const localizeRoutes = (routes: RouteObject[], locale: string = '/') => {
  const localizedRoutes: any = routes.map((route) => {
    const newRoute = { ...route };
    if (route.path) {
      newRoute.path = `/${locale}${route.path}`;
    }
    if (route.children) {
      newRoute.children = localizeRoutes(route.children, locale);
    }
    return newRoute;
  });

  return localizedRoutes;
};

export const findRouteByPath = (path: string, menu: any = []) => {
  if (!menu || !menu.length) return null;
  for (const route of menu) {
    if (route.path === path) return route;
    if (route.children) {
      const child: any = findRouteByPath(path, route.children);
      if (child) return child;
    }
  }
};

export const replaceObjectKeys = (obj: any, str: string = '') => {
  const arr = str.split('/');
  for (const key in obj) {
    if (obj[key]) {
      const idx = arr.findIndex((x) => x === obj[key]);
      if (idx !== -1) arr[idx] = `:${key}`;
    }
  }
  return arr.join('/');
};

export const getRoutePath = (location: Location, params: Params): string => {
  const { pathname } = location;

  if (!Object.keys(params).length) {
    return pathname; // we don't need to replace anything
  }

  let path = pathname;
  Object.entries(params).forEach(([paramName, paramValue]) => {
    if (paramValue) {
      path = path.replace(paramValue, `:${paramName}`);
    }
  });
  return path;
};

export const clearPathLocale = (path: string) => {
  return path
    .split('/')
    .filter((str, idx, arr) => !(str.match(/^(ru|en|uz|cr)$/i) && idx !== arr.length - 1))
    .join('/');
};

export const appNavigate = { navigate: null } as {
  navigate: null | NavigateFunction;
};

export const setAccessToken = () => {
  let hotKey = prompt('Please enter your access token:');
  if (hotKey === null || hotKey === '') {
    return;
  } else {
    localStorage.setItem(BASE_AUTH_TOKEN, hotKey);
    window.location.reload();
  }
};
